export default "__VITE_ASSET__BULbxys9__"